import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'src/app/services/auth/keycloak.service';
import { ProjectService } from 'src/app/services/project.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { PropertyService } from 'src/app/services/property/property.service';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
})
export class ProjectComponent implements OnInit {
  statusClasses = {
    'Opening Admin': 'badge-success',
    'Client Accepted': 'badge-success',
    'Project Closed': 'badge-success',
    'Client Review': 'badge-warning',
    'Work in Progress': 'badge-warning',
    'On Hold': 'badge-warning',
    'QC Review': 'badge-warning',
    'Job Cancelled': 'badge-danger',
  };
  project: any;
  sheet: String;
  folder: String = '';
  isAdmin: Boolean = false;
  isManager: Boolean = false;
  isUser: Boolean = false;
  userEmail: any;
  isContractor: any;
  isEmployee: any;
  initialData: any;
  loggedInUser: any;
  projectStaffs: any;
  projectClient: any = null;
  staff: any;
  isTaskManager: boolean;
  isControlTower: boolean;
  countryArray = [];
  shouldDisplayFeeTab: Boolean = false
  propertyId: any;
  projectPropertyId: any;
  constructor(
    private route: ActivatedRoute,
    public sharedProjectService: SharedProjectService,
    private projectService: ProjectService,
    private propertyService: PropertyService
  ) {

    if (this.route.snapshot.data &&
      this.route.snapshot.data.project && this.route.snapshot.data.staff) {
      // Fetch project and staff from resolver/params
      this.project = this.route.snapshot.data.project.data.project;
      this.staff = this.route.snapshot.data.staff.data.projectStaffs;
      // Set User Permissions
      this.setUserPermissions();
      // Set Shared ProjectDetails
      this.sharedProjectService.isAdmin = this.isAdmin;
      this.sharedProjectService.isManager = this.isManager;
      this.sharedProjectService.isTaskManager = this.isTaskManager;
      this.sharedProjectService.project = this.project;
      this.sharedProjectService.subjectProperties = [];
      this.sharedProjectService.isUser = this.isUser;
      this.sharedProjectService.userEmail = this.userEmail || "";
      this.sharedProjectService.projectStaff = this.staff;
      this.sharedProjectService.folder = this.folder;
      this.isLoggedInUserInvolvedInTheProject();
      this.sharedProjectService.dataObserver.subscribe((data: any) => {
        if (data) {
          data?.map(item => {
            if (item.key) {
              this.project[item.key] = item.value;
            }
          })
        }
        this.ngOnInit();
      });
    }
  }

  ngOnInit() {
    if (this.project && this.project.sheetId) {
      this.sheet = `https://docs.google.com/spreadsheets/d/${this.project.sheetId}/edit`;
    }
    if (this.project?.folderId) {
      this.sharedProjectService.folder = `https://drive.google.com/drive/u/1/folders/${this.project.folderId}`;
      this.folder = this.sharedProjectService.folder;
    }
    this.project.projectImage = this.sharedProjectService.projectImage;
    this.getProjectClientInformation(this.project.id);
    this.getProjectFee(this.project.id);
    this.getSubjectProperties(this.project.id);
    // this.getProjectPropertyId(this.project.id,this.propertyId);
  }

  getProjectPropertyId(projectId: any, propertyId: any) {
    this.propertyService.getProjectPropertyId(projectId, propertyId).subscribe(res=>{
      this.projectPropertyId = res[0]?.id
      this.sharedProjectService.ProjectPropertyIdSubject.next(res[0]?.id);
    })
    
  }
  


  ngOnDestroy() {
    this.sharedProjectService.projectImage = null
  }

  setUserPermissions() {

    // Check if PROJECT_ADMIN is set from keycloak
    this.isAdmin = KeycloakService.hasRoles(['PROJECT_ADMIN']);
    this.isTaskManager = KeycloakService.hasRoles(['TASK_MANAGER']);

    // Get user info
    let loggedInUser = KeycloakService.getUserData();

    // Check if users is manager
    if (this.project && this.project.accountManager && this.project.accountManager?.email == loggedInUser?.email) {
      this.isManager = true;
    }
    if (this.project && this.project.projectManager && this.project.projectManager?.email == loggedInUser?.email) {
      this.isManager = true;
    }

    // Get staff and check if loggedin user is part of project

    if (this.staff) {
      for (let i = 0; i < this.staff.length; i++) {
        if (this.staff[i].staff && loggedInUser?.email == this.staff[i].staff.email) {
          this.isUser = true;
          this.userEmail = loggedInUser?.email;
          if (this.staff[i].projectRole.name == 'Control Tower') this.isControlTower = true;
        }
      }
    }
  }
  getProjectClientInformation(projectId) {
    this.projectService.getClientInformationByProjectId(projectId).subscribe(res => {
      const projectClient = res.data.projectClient?.customer;
      if (res && res.data.projectClient && projectClient) {
        this.projectClient = res.data.projectClient;
        this.projectClient.customer['name'] =
          [projectClient.firstName, projectClient.middleName, projectClient.lastName].filter(namePart => namePart).join(' ');
      }
    })
  }

  getSubjectProperties(projectId) {
    this.projectService.getDetailsByProjectId(projectId).subscribe(res => {
      this.sharedProjectService.subjectProperties = res.data.project.properties;
      this.sharedProjectService.subjectPropertiesSubject.next(res.data.project.properties);
    })
  }



  addProjectAddress(projectId) {
    let body = Object.create(null);
    body = { propertyId: this.propertyId }
    this.projectService.editSubjectivePropertyByProjectId(projectId, body).subscribe((res) => {
      if (res && res.data && res.data.updateProperty.length > 0) {
        this.sharedProjectService.subjectProperties = body;
        this.sharedProjectService.updateParentState([
          { key: "companyAssignmentId", value: body.companyAssignmentId },
          { key: "projectPurpose", value: body.projectPurpose }
        ]);
      }
    });
  }


  getPropertyDetail(propertyTableId) {
    this.propertyService.getAll(`/property/${propertyTableId}`).subscribe((data) => {
      if (data) {
        this.sharedProjectService.propertyDetailsSubject.next(data);
        this.sharedProjectService.PropertyIdSubject.next(data?.property_id)
      }
    });
  }

  getProjectFee(projectId) {
    this.projectService.getProjectFeeByProjectId(projectId).subscribe((res) => {
      this.project.projectFee = res.data.projectFee;
    })
  }

  isLoggedInUserInvolvedInTheProject() {
    for (let data of this.sharedProjectService.projectStaff) {
      if (KeycloakService.getUserData()?.email == data.staff?.email) {
        this.shouldDisplayFeeTab = true;
        this.isLoggedInUserOnFeeSplit(true);
        return;
      };
    }
  }

  isLoggedInUserOnFeeSplit(shouldDisplayFeeTab: Boolean) {
    let projectFeeAllocation = [];
    this.projectService.getProjectFeeAllocationByProjectId(this.sharedProjectService.project.id).subscribe((res) => {
      projectFeeAllocation = res.data.projectFeeAllocations;
      for (let data of this.sharedProjectService.projectStaff) {
        if (KeycloakService.getUserData()?.email == data.staff.email) {
          // if (data.staff.employmentType === 'Contractor') {
          //   // return true
          // }
          projectFeeAllocation.map((pfa) => {
            if (pfa['staff']['id'] === data.staff.id && pfa.involvementType === "Contractor") {
              this.shouldDisplayFeeTab = shouldDisplayFeeTab && true;
              return;
            }
          })
        }
      }
    })

    this.shouldDisplayFeeTab = false;
  }

}

@Injectable({ providedIn: 'root' })
export class SharedProjectService {

  public project: any = {};
  public projectStaff = [];
  public subjectProperties = [];
  public isAdmin: Boolean = false;
  public isManager: Boolean = false;
  public isUser: Boolean = false;
  public isTaskManager: Boolean = false;
  public userEmail: string = "";
  public feeComponentVisible: boolean = false;
  public folder: String = "";
  public projectImage = null;
  public subjectPropertiesSubject = new BehaviorSubject<any>('');
  public propertyDetailsSubject = new BehaviorSubject<any>('');
  public PropertyIdSubject = new BehaviorSubject<any>('');
  public PropertyTableIdSubject = new BehaviorSubject<any>('');
  public ProjectPropertyIdSubject = new BehaviorSubject<any>('');
  public subjectivePropertyDetailSubject = new BehaviorSubject<any>('');

  isFeeComponentVisible(hide, user) {
    if (KeycloakService.getUserData().email == user.email && user.employmentType == 'Contractor') {
      this.projectStaff.push({ staff: user });
    };
  }

  private data = new Subject<string>();
  dataObserver = this.data.asObservable();

  updateParentState(data: any = null) {
    this.data.next(data);
  }
}
